import axios from "axios";
import {pathOr} from "ramda";
import {getLocale} from "@/i18n";

// const BASE = location.hostname === 'asm.ru' ? 'https://asm.ru/graphql' : 'http://dev.asm.ru/graphql';
const BASE = 'https://asm.ru/graphql';
const CALCULATOR = `calculator`;
const USERS = `users`;
const CURRENCY = `currency`;
const COUNTRY = `country`;

const get = ({url, query}) => {
  const lang = getLocale();
  return axios.post(`${BASE}/${url}/`, {
    query: `query ($lang: String) {
        ${query}
      }`,
    variables: {
      lang
    }
  })
};

/**
 *
 */
export default {
  get({commit}, {url, query}) {
    const lang = getLocale();
    return axios.post(`${BASE}/${url}`, {
      query: `query ($lang: String) {
        ${query}
      }`,
      variables: {
        lang
      }
    })
      .then(({data}) => data)
      .then(({data}) => {
        commit('set', data);
        return data;
      })
  },
  fetch({dispatch, commit, getters}) {
    return get({
      url: CALCULATOR,
      query: `
        lines (lang: $lang) {
          id,
          label,
          name,
          slug,
          description,
          capability,
          energy,
          energy_for_cube,
          employers,
          area
        },
        resources (lang: $lang) {
          name,
          label,
          measure,
          min_price,
          max_price,
          step,
          price:value,
          prices{currency{code},min,max,step,value}
        },
        ingredients (lang: $lang) {
          name,
          label,
          measure,
          min_price,
          max_price,
          step,
          price,
          purchase_measure,
          measure_multiplier,
          prices{currency{code},min,max,step,value}
        },
        recipes (lang: $lang) {
          id,
          name,
          label,
          ingredients{
            value,
            min,
            max,
            step,
            ingredient{
              id,
              name,
              label,
              measure
            }
          }
        }
      `
    })
      .then(({data}) => data)
      .then(({data}) => {
        commit('fetch', data);
        commit('preloadData', {
          currency: getters.currency,
          recipe: getters.recipe.index,
          line: getters.line
        });
        dispatch('resetCapability')
        return data;
      })
  },

  getCurrency({commit, dispatch}) {
    return dispatch('get', {
      url: CURRENCY,
      query: `
        currencies (lang: $lang) {id,name,country_iso,symbol,code,rate}
      `
    })
      .catch((error) => {
        commit('set', {currencies: {}});
        console.error(error);
      })
  },
  selectCurrency({commit, getters}, code) {
    commit('selectCurrency', code);
    commit('preloadData', {
      currency: getters.currency,
      recipe: getters.recipe.index,
      line: getters.line
    });
    commit('setCapability', getters.line.capability);
  },

  getCountry({commit, dispatch}) {
    return dispatch('get', {
      url: COUNTRY,
      query: `
        country:currentCountry (lang: $lang) {id,name,iso,currency{code}}
      `
    })
      .then((data) => {
        commit('set', {currencyCode: pathOr('USD', ['country', 'currency', 'code'], data)});

      })
      .catch((error) => {
        commit('set', {currencyCode: 'USD'});
        console.error(error);
      })
  },


  setPeriod({commit}, val) {
    commit('setPeriod', val);
  },
  resetPeriod({commit}) {
    commit('setPeriod', 30);
  },

  setCapability({commit}, capability) {
    commit('setCapability', capability);
  },

  resetCapability({commit, getters}) {
    const capability = getters.line.capability;
    commit('setCapability', capability);
  },

  setIngredientAmount({commit}, [name, val]) {
    if (['price', 'rent', 'tariff', 'energyTariff'].includes(name))
      commit('setResAmount', [name, val]);
    else
      commit('setIngAmount', [name, val]);
  },

  setIngredientPrice({commit}, [name, val]) {
    if (['price', 'rent', 'tariff', 'energyTariff'].includes(name))
      commit('setResPrice', [name, val]);
    else
      commit('setIngPrice', [name, val]);
  },

  selectLine({commit, dispatch, getters}, lineName) {
    commit('set', {currentLine: lineName});
    commit('preloadData', {
      currency: getters.currency,
      recipe: getters.recipe.index,
      line: getters.line
    });
    dispatch('resetCapability')
  },


  getPrices({commit, dispatch}) {
    return dispatch('get', {
      url: CALCULATOR,
      query: `
        linePrices{id,price}
      `
    })
      .catch((error) => {
        commit('set', {linePrices: []});
        console.error(error);
      })
  },
  whoAmI({commit, dispatch}) {
    return dispatch('get', {
      url: USERS,
      query: `
        currentUser{id,email,name,phone}
      `
    })
      .catch((error) => {
        commit('set', {currentUser: null});
        console.error(error);
      })
  },
}
